var _rect, _text, _text2, _rect2, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _text7, _rect7, _text8, _path, _polygon, _rect8, _text9, _path2, _polygon2, _rect9, _text10, _text11, _path3, _polygon3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg03ContextWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 380",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 380,
    fill: "#fafafa"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 36,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 18,
    fontWeight: 700
  }, "Context Engineering: Fill the Window Wisely")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 58,
    textAnchor: "middle",
    fill: "#666",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, "Not everything. The right information at the right time.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 90,
    width: 380,
    height: 250,
    rx: 16,
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 2.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 120,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 700
  }, "Context Window")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 140,
    width: 320,
    height: 36,
    rx: 8,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 163,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "System prompt + AGENTS.md policy")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 186,
    width: 320,
    height: 36,
    rx: 8,
    fill: "#bbf7d0",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 209,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Retrieved docs (RAG) + code snippets")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 232,
    width: 320,
    height: 36,
    rx: 8,
    fill: "#bfdbfe",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 255,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Tool schemas + past tool outputs")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 290,
    y: 278,
    width: 320,
    height: 36,
    rx: 8,
    fill: "#e5e7eb",
    stroke: "#111",
    strokeWidth: 1.8
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 301,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "History, prefs, compressed memory")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 150,
    width: 160,
    height: 50,
    rx: 10,
    fill: "#fef3c7",
    stroke: "#111",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 180,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Knowledge base")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 175 L250 200",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "254,202 244,196 248,208",
    fill: "#111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 240,
    width: 160,
    height: 50,
    rx: 10,
    fill: "#fce7f3",
    stroke: "#111",
    strokeWidth: 2
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 270,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "Repo + memory")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 265 L250 270",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "254,271 244,265 246,278",
    fill: "#111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 180,
    width: 160,
    height: 70,
    rx: 10,
    fill: "#fecaca",
    stroke: "#111",
    strokeWidth: 2
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 212,
    textAnchor: "middle",
    fill: "#111",
    fontFamily: "system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "LLM")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 780,
    y: 232,
    textAnchor: "middle",
    fill: "#444",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "reasons here")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M640 215 L690 215",
    stroke: "#111",
    strokeWidth: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "694,215 684,209 684,221",
    fill: "#111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg03ContextWindow);
export default __webpack_public_path__ + "static/media/03-context-window.911de557f12d1e130cf36a8a9e8a21d1.svg";
export { ForwardRef as ReactComponent };